import { render, staticRenderFns } from "./AccountResume.vue?vue&type=template&id=87936834"
import script from "./AccountResume.vue?vue&type=script&lang=js"
export * from "./AccountResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports